<div mat-dialog-title>
	<span translate>
		unrecognized.batch
	</span>
</div>

<div mat-dialog-content>
	<b *ngIf="unrecognizedBatch" class="delete-popup-alignment">{{unrecognizedBatch}}</b>&nbsp;
	<span translate>remove.unrecognized.batch</span>
</div>

<div mat-dialog-actions>
	<button type="button" mat-raised-button
		class="dialog-button" (click)="evtConfirm()" tabindex="-1" copoFocusMe>
		<span translate>dialog.select.batch</span>
	</button>
</div>
